export default "__VITE_ASSET__Cww6J0v4__"